import React from 'react';
import styled from '@emotion/styled';
import TymeLink from '../components/link.js';
import theme from '../design-system/theme';
import {modularScale} from '../design-system/utils';

const RoundAppButton = ({className, title, linkTarget, color = 'rgb(0, 202, 143)', big = false}) => (
    <TymeLink to={linkTarget}>
        <StyledAppButton className={className} color={color} big={big}>
            <span>{title}</span>
        </StyledAppButton>
    </TymeLink>
);

const StyledAppButton = styled('div')`
	box-sizing: border-box;
	height: ${props => props.big ? '50px' : '30px'};
	padding: 0 1.5em;
	display: inline-flex;
	align-items: center;
	background-color: ${props => props.color};
	border-radius: ${props => props.big ? '25px' : '15px'};
	color: ${theme.colors.white};
	
	@media (min-width: ${theme.breakpoints.desktop}px) {
		border-radius: ${props => props.big ? '25px' : '15px'};
		padding: 0 3em;
	}

	> span {
		width: 100%;
		white-space: nowrap;
		font-size: ${props => props.big ? modularScale(-0.5) : modularScale(-1.5) };
		font-weight: 600;
		letter-spacing: 0.1em;
		text-transform: uppercase;
        text-align: center;
	}
`;

export default RoundAppButton;
